// Import images
import Image1 from '../images/ui-project-1.png';
import Image2 from '../images/web-project-2.png';
import Image3 from '../images/mobile-project-2.png';

import DevImage1 from '../images/dev-tracker-1.png';
import DevImage2 from '../images/dev-tracker-2.png';
import DevImage3 from '../images/dev-tracker-3.png';


export const singleProjectData = {
	ProjectHeader: {
		title: 'Corporate Housing Booking Platform',
		publishDate: 'May 2022 - Apr 2025',
		tags: 'UI / Frontend / Development',
	},
	ProjectImages: [
		{
			id: 1,
			title: 'Kabul Project Management UI',
			img: Image1,
		},
		{
			id: 2,
			title: 'Kabul Project Management UI',
			img: Image2,
		},
		{
			id: 3,
			title: 'Kabul Project Management UI',
			img: Image3,
		},
	],
	ProjectInfo: {
		ClientHeading: 'About Client',
		CompanyInfo: [
			{
				id: 1,
				title: 'Name',
				details: '3Sixty',
			},
			{
				id: 2,
				title: 'Services',
				details: 'Corporate Housing Booking Platform',
			},
			{
				id: 3,
				title: 'Website',
				details: 'https://stay3sixty.com',
			},
		],
		// ObjectivesHeading: 'Objective',
		// ObjectivesDetails:
		// 	'Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio, natus! Quibusdam enim quod in esse, mollitia molestias incidunt quas ipsa accusamus veniam.',
		Technologies: [
			{
				title: 'Tools & Technologies',
				techs: [
					'JavaScript/TypeScript',
					'ReactJS',
					'NextJS',
					'Context API',
					'StripeJS',
					'Google Maps API',
					'React Hook Form',
					'Material UI',
					'Figma',
				],
			},
		],
		ProjectDetailsHeading: 'Details',
		ProjectDetails: [
			{
				id: 1,
				details:
					'Joined the development team to help build a corporate housing prop-tech platform—similar to Airbnb but tailored for B2B and corporate clients. The product now generates millions in annual revenue with thousands of monthly bookings. Highlights include: ',
			},
			{
				id: 2,
				details:
					'● Collaborated with product managers to prioritize features, gather requirements, and deliver high-quality code on time, while maintaining a focus on user needs and business objectives.',
			},
			{
				id: 3,
				details:
					'● Co-led the design and implementation of a hotel booking UI that integrates with a third-party API, enabling seamless access to 300,000+ listings with optimized performance.',
			},
			{
				id: 4,
				details:
					'● Built dozens of pixel-perfect, reusable components and responsive pages, with a focus on UX, accessibility, and performance.',
			},
			{
				id: 5,
				details:
					'● Partnered with UX/UI designers to translate client and user needs into clear, thoughtful Figma designs that aligned with business goals and improved the overall user experience.',
			},
			{
				id: 6,
				details:
					'● Worked closely with backend engineers to define API payload structures and streamline data integration, enabling a performant and maintainable frontend experience.',
			},
			{
				id: 7,
				details:
					`● Refactored pages from JavaScript to TypeScript, reducing tech debt and improving code maintainability, type safety, and developer efficiency.`,
			},
		],
	},
};

export const crudProjectData = {
	ProjectHeader: {
		title: 'DevTracker',
		publishDate: 'May 2025',
		tags: 'Fullstack / CRUD / Development',
	},
	ProjectImages: [
		{
			id: 1,
			title: 'DevTracker',
			img: DevImage1,
		},
		{
			id: 2,
			title: 'DevTracker',
			img: DevImage2,
		},
		{
			id: 3,
			title: 'DevTracker',
			img: DevImage3,
		},
	],
	ProjectInfo: {
		ClientHeading: 'About Project',
		CompanyInfo: [
			{
				id: 3,
				title: 'Website',
				details: 'https://devtrackerapp.netlify.app/dashboard',
			},
		],
		ObjectivesHeading: 'Objective',
		ObjectivesDetails:
			'Task Management App',
		Technologies: [
			{
				title: 'Tools & Technologies',
				techs: ['TypeScript', 'React', 'NextJS', 'Zustand', 'Zod', 'React Query', 'Tailwind CSS', 'Jest', 'Cypress'],
			},
		],
		ProjectDetailsHeading: 'Details',
		ProjectDetails: [
			{
				id: 1,
				details: 'A full-featured task management platform inspired by Jira, designed with a modern UI and real-world usability in mind. Built with a strong emphasis on clean architecture, scalability, and frontend best practices.'
			},
			{
				id: 2,
				details: 'Key Features:'
			},
			{
				id: 3,
				details: '• JWT Authentication: Secure login and protected routes.'
			},
			{
				id: 4,
				details: '• Drag-and-Drop Task Board: Reorder tasks with ease using an intuitive Kanban-style interface.'
			},
			{
				id: 5,
				details: '• Task Management: Create, update, delete tasks with support for assignees, tags, and priority.'
			},
			{
				id: 6,
				details: '• Commenting System: Inline discussions on tasks to support team collaboration.'
			},
			{
				id: 7,
				details: '• Form Validation: Type-safe validation using Zod and React Hook Form.'
			},
			{
				id: 8,
				details: '• State Management: Efficient and scalable with Zustand and React Query.'
			},
			{
				id: 9,
				details: '• Testing: Jest unit tests and Cypress end-to-end tests coverage.'
			},
		],
		},
};
